module.exports = __webpack_public_path__ + "ai-fab-backgroundwpdef4766fea96502a61d720e893071f92.png";